export const useAnimations = () => {
	const FadeIn = {
		opacity: 1,
		zIndex: 0
	};

	const FadeOut = {
		opacity: 0,
		zIndex: -10
	};

	const SlideInRight = {
		opacity: 1,
		x: '0vw'
	};

	const SlideOutRight = {
		opacity: 0,
		x: '100vw'
	};

	//scale, bounce, etc

	return {
		FadeIn,
		FadeOut,
		SlideInRight,
		SlideOutRight
	};
};
